function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHtml5 = function SvgHtml5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_9_",
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "93.063,116.909 122.719,449.542 255.8,486.486      389.249,449.489 418.938,116.909    ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E44D26"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_8_",
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,184.903H153.702l0.977,10.945l10.027,112.422H256     v-40.795h-53.984l-3.729-41.775H256V184.903z M210.386,361.206l-2.905-32.536h-40.953l5.716,64.056l83.568,23.198l0.188-0.052     v-42.445l-0.179,0.048L210.386,361.206z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EBEBEB"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_7_",
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "256,144.106 256,458.208 363.832,428.313      389.203,144.106    ",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F16529"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_6_",
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.858,308.271h50.236l-4.736,52.91l-45.5,12.281v42.442     l83.634-23.179l0.614-6.892l9.587-107.403l0.995-10.955h-94.83V308.271z M255.858,184.903V225.7H354.4l0.818-9.17l1.859-20.682     l0.975-10.945H255.858z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_5_",
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.079,46.997h-18.965V26.514h-20.731v62.028h20.732V67.771h18.964     v20.771h20.732V26.514h-20.733V46.997z M192.824,47.083h18.252v41.459h20.733V47.083h18.26V26.514h-57.245V47.083z      M294.07,48.309l-13.299-21.795h-21.617v62.028h20.285V57.797l14.273,22.055h0.357l14.263-22.055v30.745h20.646V26.514h-21.626     L294.07,48.309z M360.036,68.039V26.514h-20.738v62.028h49.894V68.039H360.036z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHtml5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/html5.5080b233.svg";
export { ForwardRef as ReactComponent };